module.exports = __webpack_public_path__ + "9a941481a043490615899465eda46e11.svg";